<template>
    <v-layout row wrap v-redirect-if-no-permission:REGISTERED_CAPTAINS>
        <loading-component :value="loading"/>
        <v-dialog :value="!!select_user" @input="select_user = null" max-width="50%">
            <v-card v-if="!!select_user" class="elevation-1 pa-4">
                <choose-time v-model="select_user.start_time" label="From"/>
                <choose-time v-model="select_user.end_time" label="To"/>
                <choose-date v-model="select_user.create_date" label="Create Date"/>

                <choose-user-multi v-model="select_user.user_id" :multi="false"
                                   label="User"/>

                <v-btn @click="saveEvent">
                    Save
                </v-btn>

            </v-card>
        </v-dialog>
        <v-dialog :value="!!activeEvent" @input="activeEvent = null" max-width="50%">
            <v-card>
                <v-card-text class="title ">
                    <choose-date v-model="deletedDate" label="Deleted Date"/>
                    <br>
                    Do you want to delete this shift?
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="activeEvent = null">Cancel</v-btn>
                    <v-btn color="red" @click="deleteEvent">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog :value="!!activeUpdate" @input="activeUpdate = null" max-width="50%">
            <v-card>
                <v-card-text class="title ">
                    <choose-date v-model="update_date" label="Updated Date"/>
                    <br>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="cancelUpdate">Cancel</v-btn>
                    <v-btn color="green" @click="updateEvent">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-flex sm3>
            <v-checkbox v-model="filter_model.show_all" label="Show all"></v-checkbox>
        </v-flex>
        <v-flex sm9>
            <choose-user-multi v-show="!filter_model.show_all" v-model="filter_model.user_id"
                               :multi="false"></choose-user-multi>
        </v-flex>
        <v-flex sm12>
            <full-calendar
                    ref="calendar"
                    default-view="timeGridWeek"
                    :events="events"
                    :droppable="false"
                    :editable="true"
                    :selectable="true"
                    :all-day-slot="false"
                    :business-hours="{startTime: '07:00:00', endTime:'23:59:59',daysOfWeek:[0,1,2,3,4,5,6]}"
                    slot-duration="00:15:00"
                    event-order="start"
                    :plugins="calendarPlugins"
                    @select="select"
                    @eventDrop="eventDrop"
                    @datesRender="handleDateClick"
                    @eventClick="({event}) => activeEvent = event"
                    @eventResize="eventDrop"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import FullCalendar from "@fullcalendar/vue";
    import FullCalendarTimeGrid from "@fullcalendar/timegrid";
    import FullCalendarInteraction from "@fullcalendar/interaction";
    import moment from "moment";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";


    export default {
        components: {LoadingComponent, ChooseUserMulti, ChooseTime, ChooseDate, FullCalendar},
        name: "user-schedule",
        title: "User Schedule",
        data() {
            return {
                date: null,
                filter_model: {
                    show_all: true,
                    user_id: null
                },
                loading: false,
                activeBooking: null,
                activeEvent: null,
                activeUpdate: null,
                update_date: moment().format("YYYY-MM-DD"),
                sliceInfoDialog: false,
                slice: null,
                data: [],
                start: null,
                end: null,
                deletedDate: moment().format("YYYY-MM-DD"),
                select_user: null
            }
        },
        computed: {
            calendarPlugins() {
                return [FullCalendarTimeGrid, FullCalendarInteraction];
            },
            events() {
                return this.data.map(this.scheduleToEvent);
            }
        },
        mounted() {
            //this.getData();
        },
        watch: {
            start() {
                this.getData();
            },
            filter_model: {
                handler(val) {
                    if (!val.show_all && !val.user_id) {
                        return;
                    }
                    this.getData();
                },
                deep: true
            }
        },
        methods: {
            getData() {
                this.loading = true;
                let query = '';
                if (!this.filter_model.show_all && this.filter_model.user_id) {
                    query = `?user_id=${this.filter_model.user_id}`;
                }
                this.axios.get(this.api.ACTIONS.USER_SCHEDULE + query)
                    .then(
                        ({data: {data}}) => this.data = data
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            handleDateClick({view}) {
                this.start = moment(view.activeStart).format("YYYY-MM-DD");
                this.end = moment(view.activeEnd).format("YYYY-MM-DD");
            },
            eventDrop({event, revert}) {
                this.activeUpdate = true;
                this.event = event;
                this.revert = revert;

            },
            updateEvent() {

                const event = this.event;
                const revert = this.revert
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const start_time = moment(event.start).format("HH:mm");
                const end_time = moment(event.end).format("HH:mm");
                const weekday_id = moment(event.start).day();
                const update_date = this.update_date;
                this.axios.put(this.api.ACTIONS.USER_SCHEDULE + '/' + event.id, {
                    start_time,
                    end_time,
                    update_date,
                    weekday_id
                })
                    .catch(revert)
                    .finally(() => this.loading = false);
                this.activeUpdate = null;


            },
            cancelUpdate() {
                this.activeUpdate = null;
                const revert = this.revert;
                revert();
            },
            deleteEvent() {

                this.loading = true;
                const deletedDate = this.deletedDate;
                this.axios.delete(this.api.ACTIONS.USER_SCHEDULE + '/delete/' + this.activeEvent.id + '/' + deletedDate)
                    .then(
                        () => {
                            this.data = this.data.filter(({id}) => id != this.activeEvent.id)
                        }
                    )
                    .finally(
                        () => {
                            this.activeEvent = null;
                            this.loading = false;
                            this.deletedDate = null;
                        }
                    )
            },
            scheduleToEvent(data) {
                return {
                    id: data.id,
                    title: data.user.first_name + ' ' + data.user.last_name,
                    start: moment().startOf('week').add(data.weekday_id, 'days').add(data.start_time.split(":")[0], 'hours').add(data.start_time.split(":")[1], "minutes").toDate(),
                    end: moment().startOf('week').add(data.weekday_id, 'days').add(data.end_time.split(":")[0], 'hours').add(data.end_time.split(":")[1], "minutes").toDate(),
                };
            },
            async saveEvent() {
                if (!this.select_user.user_id) {
                    alert("Enter user info");
                    return;
                }

                this.loading = true;
                try {
                    const {data: {data}} = await this.axios.post(
                        this.api.ACTIONS.USER_SCHEDULE,
                        this.select_user
                    );

                    this.data = [...this.data, data];
                    this.select_user = null;
                } catch (e) {
                    alert(e.response.data.message);
                } finally {
                    this.loading = false;
                }

            },
            select(info) {
                const {startStr, endStr} = info;


                if (moment(startStr).format("YYYY-MM-DD") === moment(endStr).format("YYYY-MM-DD")) {
                    const start_time = moment(startStr).format("HH:mm");
                    const end_time = moment(endStr).format("HH:mm");

                    this.select_user = {
                        user_id: null,
                        start_time,
                        end_time,
                        weekday_id: moment(startStr).day()
                    };

                } else {
                    alert('must be on same day');
                }
            }
        }
    }
</script>

<style scoped>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timegrid/main.css';

    div >>> .fc-toolbar.fc-header-toolbar {
        display: none;
    }

    .removebtn {
        color: black;
        position: absolute;
        top: 0;
        right: 0;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 50%;
        font-size: 10px;
        cursor: pointer;
        background-color: #FFF
    }
</style>
